module.exports = __webpack_public_path__ + "img/logo.ed06f9e7.png";